export default __webpack_public_path__ + "static/71b5a43c-916f-4643-9fc3-e336e5b986ac-1007b87b12b12b1da86cc3fd4e349443.woff";